<template>
  <cookie-law
    theme="blood-orange"
    storageType="localStorage"
    :button-text="$t('Accept')"
    :button-decline="true"
    :button-decline-text="$t('Decline')"
    button-decline-class="Cookie__button"
    :button-link="{ name: 'Privacy' }"
    :button-link-text="$t('More information')"
    :message="$t('This site uses cookies to offer you a better user experience.')"
    @accept="enableTracking"
  />
</template>

<script>
 import CookieLaw from 'vue-cookie-law'

 export default {
   components: { CookieLaw },
   methods: {
     enableTracking() {
      //  this.$gtag.enable()
     this.$gtag.config({
        enabled: true
      });
     }
   }
 }
</script>

